import AuthStore from '../stores/Auth';
import { Temporal } from '@js-temporal/polyfill';

export interface IErrorContent {
    error: string;
    error_description: string;
    [key: string]: string;
}

export interface IRestResponse<T> {
    is_error?: boolean;
    error_content?: IErrorContent,
    content?: T
};

export default class RestUtilities {

    static get<T>(url: string): Promise<IRestResponse<T>> {
        return RestUtilities.request<T>('GET', url);
    }

    static delete(url: string): Promise<IRestResponse<void>> {
        return RestUtilities.request<void>('DELETE', url);
    }

    static put<T>(url: string, data: Object | string): Promise<IRestResponse<T>> {
        return RestUtilities.request<T>('PUT', url, data);
    }

    static post<T>(url: string, data: Object | string): Promise<IRestResponse<T>> {
        return RestUtilities.request<T>('POST', url, data);
    }

    static saveAs(blob: Blob, fileName: string) {
        const url = URL.createObjectURL(blob);
        const a = document.createElement('a');
        a.href = url;
        a.download = fileName;
        a.style.display = 'none';
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);
        URL.revokeObjectURL(url);
    }
    private static request<T>(method: string, url: string, data: Object | string = null): Promise<IRestResponse<T>> {

        let isJsonResponse: boolean = false;
        let isBadRequest = false;
        let body = data;
        let headers = new Headers();

        headers.set('Authorization',`Bearer ${AuthStore.getToken()}`);
        headers.set('Accept','application/json');
        headers.set('Cache-Control', 'no-cache')
        headers.set('Pragma', 'no-cache')

        if (data) {
            if ((typeof data === 'object')) {
                headers.set('Content-Type','application/json');

                const dateReplacer = function(key: any,value: any) {
                    if(this[key] instanceof Date) {
                       // return moment(this[key]).format('YYYY-MM-DDTHH:mm:ss')
                       return Temporal.Instant.from(new Date(this[key]).toISOString())
                            .toZonedDateTimeISO('UTC')
                            .toPlainDateTime()
                            .toString();
                    }

                    return this[key]
                }

                body = JSON.stringify(data, dateReplacer);
            } else {
                headers.set('Content-Type','application/x-www-form-urlencoded');
            }
        }

        return fetch(url, {
            method: method,
            headers: headers,
            body: <string>body,
        }).then((response:any) => {
            if (response.status == 401) {
                // Unauthorized; redirect to sign-in
                AuthStore.removeToken();
                AuthStore.removeRole()
                AuthStore.removePersonalNr()
                window.location.replace(`/signin`);
            }

            isBadRequest = (response.status == 400);

            let responseContentType = response.headers.get("content-type");
            if (responseContentType && responseContentType.indexOf("application/json") !== -1) {
                isJsonResponse = true;
                return response.json();
            } else {
                return response.text();
            }
        }).then((responseContent: any) => {

            if(typeof responseContent.error != 'undefined' && responseContent.error) {
                let responseModel: IRestResponse<T> = {
                    is_error: true,
                    error_content: responseContent.error,
                    content: null
                }
                throw responseModel
            }

            if(isBadRequest) {
                let responseModel: IRestResponse<T> = {
                    is_error: true,
                    error_content: responseContent,
                    content: null
                }
                throw responseModel
            }

            let response: IRestResponse<T> = {
                is_error: isBadRequest,
                error_content: isBadRequest ? responseContent.data : null,
                content: isBadRequest ? null : responseContent.data
            };
            return response;
        });
    }
}
